import { Badge, Card, CardBody, Col } from "reactstrap";
import DashboardCommonHeader from "../../../CommonComponents/DashboardCommonHeader/DashboardCommonHeader";
import { CurrentActivityTitle } from "../../../../Constants/Constants";
import { Image, LI, P, UL } from "../../../../AbstractElements";
import { CurrentActivityData } from "../../../../Data/General/Dashboard/Ecommerce";
import { dynamicImage } from "../../../../Utils";

const CurrentActivity = () => {
  return (
    <Col xxl="4" sm="6" className="box-col-6">
      <Card>
        <DashboardCommonHeader title={CurrentActivityTitle} dropdownClass="dropdown-toggle" />
        <CardBody className="timeline-card">
          <div className="activity-timeline">
            {CurrentActivityData.map((item, index) => (
              <div className="d-flex align-items-start" key={index}>
                <div className="activity-line" />
                <div className={`activity-dot-${item.color}`} />
                <div className="flex-grow-1">
                  <P className="mt-0 todo-font">
                    <span className={`font-${item.color}`}>{item.date}</span>&nbsp;{item.time}
                    {item.text && (<Badge color="primary" className="ms-2">{item.text}</Badge>)}
                  </P>
                  <span className="f-w-600">{item.title}</span>
                  <P className="mb-0 activity-text">{item.description}</P>
                  {item.text && (
                    <UL className="img-wrapper simple-list flex-row">
                      <LI><Image className="img-fluid" src={dynamicImage("dashboard-2/timeline/5.png")} alt="" /></LI>
                      <LI><Image className="img-fluid" src={dynamicImage("dashboard-2/timeline/6.png")} alt="" /></LI>
                    </UL>
                  )}
                </div>
                <i className={`fa fa-circle circle-dot-${item.color} pull-right`} />
              </div>
            ))}
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default CurrentActivity;
